import { _ } from "i18n";
import { AgeCategoryOptions } from "features/discover/types";
import { DatagridBackendFilterType, DatagridFilterInputType, type FilterConfig } from "../../types";
import { DiscoverGamesFilterField } from "../constants";

export const basicFilters = {
	core(): FilterConfig[] {
		return [
			{
				id: DiscoverGamesFilterField.Id,
				label: _("discover.gamesTable.filter.id"),
				type: DatagridFilterInputType.Text,
				field: DiscoverGamesFilterField.Id,
				filterType: DatagridBackendFilterType.Search,
				placeholder: _("discover.gamesTable.filterPlaceholder.id"),
			},
			{
				id: DiscoverGamesFilterField.Date,
				label: _("discover.gamesTable.filter.date"),
				type: DatagridFilterInputType.Daterange,
				field: DiscoverGamesFilterField.Date,
				filterType: DatagridBackendFilterType.Datetimerange,
			},
			{
				id: DiscoverGamesFilterField.CreatedAt,
				label: _("discover.gamesTable.filter.createdAt"),
				type: DatagridFilterInputType.Daterange,
				field: DiscoverGamesFilterField.CreatedAt,
				filterType: DatagridBackendFilterType.Datetimerange,
			},
			{
				id: DiscoverGamesFilterField.Country,
				label: _("discover.gamesTable.filter.country"),
				type: DatagridFilterInputType.Multiselect,
				field: DiscoverGamesFilterField.Country,
				filterType: DatagridBackendFilterType.Inarray,
				options: [],
				placeholder: _("discover.gamesTable.filterPlaceholder.country"),
			},
		];
	},
	ageCategory(): FilterConfig {
		return {
			id: DiscoverGamesFilterField.AgeCategory,
			label: _("discover.gamesTable.filter.ageCategory"),
			type: DatagridFilterInputType.Select,
			field: DiscoverGamesFilterField.AgeCategory,
			filterType: DatagridBackendFilterType.Exact,
			options: AgeCategoryOptions,
			placeholder: _("discover.gamesTable.filterPlaceholder.ageCategory"),
		};
	},
};
